(function () {
  // The store has two underlying "Taille" filters (one linked to Shopify's
  // standard Size taxonomy, one plain text for the handful of products that
  // don't map to it — socks, non-standard ceremony ranges). Both render as
  // separate accordions with the same "Taille" heading. This merges them
  // into a single accordion per filter form, without touching the real
  // checkbox inputs (moved, not cloned) so filtering keeps working exactly
  // as before.

  // Different filter_type settings (horizontal / vertical / drawer) render
  // completely different markup (.facets__summary-label vs a plain <span> in
  // .mobile-facets__summary, .facets__list vs .mobile-facets__list...), so
  // detection stays generic rather than tied to one variant's class names.
  function summaryLabel(details) {
    var summary = details.querySelector('summary');
    if (!summary) return '';
    // Strip the trailing "(n)" active-count badge before comparing.
    return summary.textContent.replace(/\s+/g, ' ').replace(/\(\d+\)\s*$/, '').trim();
  }

  function findList(details) {
    return details.querySelector('.facets__list, .facets__list--vertical, .mobile-facets__list');
  }

  // Some sizes exist as two separate underlying values with the exact same
  // visible text (a handful of products still carry the value as plain text
  // instead of the linked taxonomy entry) - naively concatenating the two
  // lists then shows "24mois/80cm" twice with two different counts.
  //
  // IMPORTANT: Shopify combines different filter fields (filter.v.option.size
  // vs filter.v.option.taille) with AND, not OR. Checking both at once for
  // the same value returns zero results, not the combined set - confirmed
  // live. So the duplicate's checkbox is NOT synced or summed into the
  // count; it's simply hidden. The visible row keeps the primary (taxonomy)
  // filter's real, correct count and behaviour. The few products only
  // reachable through the plain-text duplicate stay outside this filter,
  // same as the rest of the already-accepted "left as is" set.
  function valueTextOf(li) {
    var span = li.querySelector('.facet-checkbox__text-label');
    return span ? span.textContent.trim() : null;
  }

  function mergeWithin(form) {
    var detailsEls = Array.prototype.filter.call(form.querySelectorAll('details.js-filter'), function (d) {
      return summaryLabel(d) === 'Taille';
    });
    if (detailsEls.length < 2) return;

    var primary = detailsEls[0];
    var primaryList = findList(primary);
    if (!primaryList) return;

    var existingByText = {};
    Array.prototype.forEach.call(primaryList.children, function (li) {
      var t = valueTextOf(li);
      if (t) existingByText[t] = li;
    });

    for (var i = 1; i < detailsEls.length; i++) {
      var extra = detailsEls[i];
      var extraList = findList(extra);
      if (extraList) {
        while (extraList.firstElementChild) {
          var li = extraList.firstElementChild;
          var text = valueTextOf(li);
          var dup = text && existingByText[text];

          if (dup) {
            // Same visible size, but the two checkboxes cannot both be
            // checked without breaking the query (see note above) - hide
            // the duplicate row and leave its checkbox alone, untouched.
            li.style.display = 'none';
            li.setAttribute('data-merged-duplicate', 'true');
          }

          primaryList.appendChild(li);
          if (text && !dup) existingByText[text] = li;
        }
      }
      extra.setAttribute('hidden', '');
      extra.style.display = 'none';
    }
  }

  function mergeAll() {
    ['#FacetFiltersForm', '#FacetFiltersFormMobile', '#FacetFiltersPillsForm'].forEach(function (selector) {
      var form = document.querySelector(selector);
      if (form) mergeWithin(form);
    });
  }

  function init() {
    mergeAll();

    ['#main-collection-filters', '.facets-container'].forEach(function (selector) {
      var target = document.querySelector(selector);
      if (!target) return;
      new MutationObserver(function () {
        mergeAll();
      }).observe(target, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
